// Политика выполнения запроса. Сервисы декларируют её на метод, а исполняет одна точка
// (api/httpClient → request). Так «таймауты/повторы/refresh» живут в одном месте без копипасты.

export interface RetryPolicy {
  /** Сколько повторов после первой неудачи (всего попыток = attempts + 1). */
  readonly attempts: number;
  readonly baseDelayMs: number;
  readonly maxDelayMs: number;
}

export interface RequestPolicy {
  /** Навешивать Authorization + включать refresh на 401. По умолчанию true. */
  readonly auth?: boolean;
  /** Безопасно ли повторять. По умолчанию: GET → true, остальные → false. */
  readonly idempotent?: boolean;
  /** Явная политика повторов или false для отключения. По умолчанию выводится из idempotent. */
  readonly retry?: RetryPolicy | false;
  readonly timeoutMs?: number;
  readonly signal?: AbortSignal;
  /** Idempotency-Key для безопасного повтора мутаций (если бэкенд поддерживает). */
  readonly idempotencyKey?: string;
}

export const DEFAULT_RETRY: RetryPolicy = {
  attempts: 2,
  baseDelayMs: 300,
  maxDelayMs: 4000,
};

export const DEFAULT_TIMEOUT_MS = 15_000;
